import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ButtonComponent, LinkCellComponent, TableColumn, TableComponent, TextInputComponent } from 'ddmo-storybook-lib';
import { CommonModule, DatePipe } from '@angular/common';
import { SharedService } from '../../shared/services/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { FooterComponentLayout } from '../../shared/components/footer/footer.component';
import { LoaderService } from '../../shared/services/loader.service';
import { environment } from '../../../environments/environment';
import { catchError, throwError } from 'rxjs';
import { AuthTokenService } from '../../shared/services/auth0-token.service';
import { EditProfileAdminComponent } from '../popups/edit-profile-admin/edit-profile-admin.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-admin',
    imports: [ CommonModule, ButtonComponent, TextInputComponent, TableComponent, MatPaginator,
        ReactiveFormsModule, HeaderComponent, FooterComponentLayout],
    templateUrl: './admin.component.html',
    styleUrl: './admin.component.scss'
})
export class AdminComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  isSubmitted: boolean = false;
  rolesToCheck = ['provider_mo', 'provider_oos', 'provider_sc'];
  pageIndex: number = 0;
  searchString!: string;
  isLoading: boolean=false;
  totalRecords: number = 0;
  pageNumber: number = 1;
  pageSize: number = 50;
  recordsPerPage: number = 5;
  totalDisplayLength = 0;
  totalPages = 0;
  payload:any={};
  public dataSource = new MatTableDataSource<any>([]);
  public tableColumns: TableColumn[] = [
    {
      columnId: 'lastName',
      columnLabel: 'Last name',
      sort: true,
      headerData: null,
      columnData: null,
      caseInsensitive : true
    },
    {
      columnId: 'firstName',
      columnLabel: 'First name',
      sort: true,
      headerData: null,
      columnData: null,
      caseInsensitive : true
    },
    {
      columnId: 'username',
      columnLabel: 'Username',
      sort: true,
      headerData: null,
      columnData: null,
      caseInsensitive : true
    },
    {
      columnId: 'action',
      columnLabel: 'Action',
      sort: true,
      headerData: null,
      columnData: {
        cellType: LinkCellComponent,
        data: {
          label: 'Impersonate',
          actionData: 'userId'
        },
         otherParams: 'impersonate'
      },
      caseInsensitive : true
    },
    {
      columnId: 'edit',
      columnLabel: '',
      sort: true,
      headerData: null,
      columnData: {
        cellType: LinkCellComponent,
        data: {
          label: 'Edit',
          actionData: 'userId'
        },
         otherParams: 'edit'
      },
      caseInsensitive : true
    }

  ];
  customErrorMessages = {
    required: 'Please enter a minimum of 2 characters.',
    minlength:'Please enter a minimum of 2 characters.'
  };
constructor(private formBuilder: FormBuilder,
  private sharedService:SharedService, private router: Router, private loaderService: LoaderService,
  private datePipe: DatePipe, private urlRoute: ActivatedRoute, private authTokenService: AuthTokenService,
  private dialog: MatDialog
) {

}
  public adminSearchForm = this.formBuilder.group({
    searchText: ['',[Validators.minLength(2)]]
  })
 ngOnInit() {
  this.urlRoute.queryParams.subscribe(params => {
    if (params['code'] && !localStorage.getItem('auth0_id_token')) {
      this.callToken();
    }else if(!this.authTokenService.isAuthenticated()){

      window.location.href = environment.redirectUrlAfterRegister

    }
  });
    this.totalDisplayLength = this.dataSource.data.length;
  }
  ngAfterViewInit(){
    // this.cdr.detectChanges();
    this.dataSource.filteredData.length = this.totalRecords;
    this.dataSource.data.length = this.totalRecords;
    
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
  }
  onPageChange(event: any) {
    const pageLength = event.pageSize * (event.pageIndex + 1);
    if(pageLength > this.totalDisplayLength && pageLength < this.totalRecords  ){
      this.pageNumber +=1;
      this.getUsersByPageSize();
    }
  }
    getUsersByPageSize() {
    this.payload['pageNumber'] = this.pageNumber;
    this.submitSearch(this.pageNumber)
    
  }
  
  submitSearch(pageNumber?:any) {
    this.setTableCoulumns();
    if(pageNumber==undefined){
      this.pageNumber=1;
      this.pageIndex=0;
      this.payload.pageNumber=1;
      this.dataSource.data=[];
      this.totalRecords=0;
    }
    this.validateAllFormFields(this.adminSearchForm);
    
    const searchControl = this.adminSearchForm.get('searchText');
    this.searchString = (searchControl?.value?.trim())!;
    if (!searchControl?.value) {
      searchControl?.setErrors({ required: true });
      searchControl?.markAsTouched();
    }
    else {
      this.searchString = searchControl?.value?.trim();
      const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.searchString);
      if(this.searchString.length >= 2){
      this.adminSearchUserAudit(this.searchString)
        this.isLoading=true;
        this.isLoading=true;
        this.payload["npi"]=this.searchString?this.searchString : "";
        this.payload["adminSearch"]=true;
        this.payload["pageSize"]=this.pageSize;
        this.payload["pageNumber"]=this.pageNumber;

      this.sharedService.searchUser(this.payload).subscribe({
        next: (data:any) => {
          if (data?.users?.length > 0) {
            let tempList=data?.users;
            this.totalRecords = data['totalRecords'];
            this.dataSource.data = [...this.dataSource.data, ...tempList]
          this.dataSource.data = this.dataSource.data.filter((el: any) => !!el);
          this.totalDisplayLength = this.dataSource.data.length;
            this.ngAfterViewInit();
            this.isLoading=false;
            }
            this.isSubmitted =  !this.dataSource.data.length;
        },      
        error: (err:any) => { 
          this.sharedService.logError("APIFailed", "FileAdminComponent - searchUser, Method:submitSearch", this.router.url.split('?')[0], err).subscribe();
          this.dataSource.data = [];
          this.isSubmitted = true;
          this.isLoading=false;
        }
      });
    }
    
    
  }
  }
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      } else {
        control?.markAsTouched({ onlySelf: true });
      }
    });
  }

  onTableClick(event: any) {
    const element: any = this.dataSource.data.find((el: any) => el.userId === event.data);
    if(event.otherParams == 'edit'){
      const dialogRef = this.dialog.open(EditProfileAdminComponent, {
        width: '700px', 
        disableClose: true, 
        panelClass: 'edit-profile-dialog', // Optional: for custom styling
        data: { userId: element.userId, userName : element.username}
      });
    
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.dataSource.data = this.dataSource.data.map((row: any) =>
            row.userId === result.userId
              ? { ...row, username: result.userName }
              : row
          );
        }
      });
    }else{
      this.loaderService.show();
      const loginUserId = localStorage.getItem("loginUserId");
      localStorage.setItem("loggedUserDetails",JSON.stringify(element));
      const reqPayload = {
        "userId": element.userId,
        "firstName":element.firstName,
        "lastName":element.lastName,
        "emailAddress": element.emailAddress,
        "phoneNumber": element.phoneNumber,
        "activeFlg": 1,
        "modifiedUserId": Number(loginUserId),
        "modifiedDate": this.datePipe.transform(new Date(), 'MM-dd-yyyy'),
        "impersonatedByUserId": Number(loginUserId),
        "trailWebSessionId": element.trailWebSessionId,
      }
  
      this.sharedService.updateUser(reqPayload).subscribe({
        next: (data) => {
          if (data?.userId) {
            localStorage.setItem("impersonatedUser", element.username);
            localStorage.setItem("impersonatedUserId", element.userId);
            this.router.navigate(['/landing'])           
          }
        },
        error: (err) => {
          this.sharedService.logError("APIFailed", "FileAdminComponent - updateUser, Method:onTableClick", this.router.url.split('?')[0],err).subscribe(); 
        }
      });
    }
  }

  restrictNonNumeric(event: KeyboardEvent): void {
    this.sharedService.preventNonNumeric(event);
   }

   callToken(){
    this.urlRoute.queryParams.subscribe(params => {
      const code = params['code'];
      const state = params['state'];
      let payload ={
        grant_type: 'authorization_code',
        client_id: environment.auth0Config.clientIdInternal,
        code: code,
        redirect_uri: environment.redirect_uri_internal
      }
      this.sharedService.getAuthToken(payload).subscribe({
        next: (data:any) => {
          this.sharedService.setStorageAuth0(data, 'internal')
          this.callDdmoToken(data.access_token, data.id_token)
        },      
        error: (err:any) => { 
          this.sharedService.logError("APIFailed", "FileAdminComponent - getAuthToken, Method:callToken", this.router.url.split('?')[0], err).subscribe();
          this.authTokenService.logout();
        }
      });
    });
   }

   callDdmoToken(accessToken:any,idToken:any){
    this.sharedService.callToken(idToken).pipe(catchError((error:any)=>{
        return throwError(() => { 
        this.sharedService.logError("APIFailed", "FileAdminComponent - callToken, Method:callDdmoToken", this.router.url.split('?')[0], error).subscribe();
        }) 
      }))
      .subscribe((response:any)=>{
        let ddmoToken = response.ddmo?.accessToken
        localStorage.setItem('accessToken', ddmoToken)
        localStorage.setItem('ddmoTokenExpiry', response.ddmo?.expiresOn);
        this.authTokenService.initializeAuthState();
        this.sharedService.saveUserDetails(idToken)
      })
    
  }

  setTableCoulumns(){
    const operations = localStorage.getItem('loginUserOperations')
    const userOperations = operations? JSON.parse(operations) : []
    const hasIMP = userOperations?.some((op:any) => op.operationName === 'IMP');
    const hasEDIT = userOperations?.some((op:any) => op.operationName === 'EDITACCOUNT');
    if (!hasIMP && hasEDIT) {
      const editColumn = this.tableColumns.find(c => c.columnId === 'edit');
      if (editColumn) editColumn.columnLabel = 'Action';
    }
     
    this.tableColumns = this.tableColumns.filter(col => {
      if (col.columnId === 'action') return hasIMP;
      if (col.columnId === 'edit') return hasEDIT;
      return true;
    });
  }

  adminSearchUserAudit(searchText:any){
    let auditLog:any={};
    auditLog["websiteCodeId"] = 50;
    auditLog["trailType"]='Search';
    auditLog["trailWebSessionId"]=localStorage.getItem("trailWebSessionId")?.toUpperCase();
    auditLog["absolutePath"]=this.router.url.split('?')[0];
    let userId = parseInt(localStorage.getItem("loginUserId")!);
    auditLog["userId"] = userId ? userId : 0
    auditLog["impersonateId"]=0;
    auditLog["searchText"]= searchText
    this.sharedService.logWebTrailSearch(auditLog).subscribe(data=>{
    });
  }

}
